import { CSV_MAPPING_ACTION_TYPE } from '../actions';

const initialState = {};

const csvMappingsMetadataReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CSV_MAPPING_ACTION_TYPE.GET_CSV_MAPPING_METADATA:
      return payload || state;

    default:
      return state;
  }
};

export default csvMappingsMetadataReducer;
